<template>
	<div class=" ">
		<!-- <top></top> -->
		<div class="cont padding-top">
			<el-carousel height="505px">
			      <el-carousel-item v-for="item in banner" :key="item.id">
			        <img class="banner" @click="gobanlink(item)" :src="item.img" >
			      </el-carousel-item>
			    </el-carousel>
			<div class="margin-top flex justify-between">
				<div class="card flex flex-direction justify-center align-center pointer" @click="golink('center','release')">
					<img class="release" src="../../assets/img/release.png" >
					<p class="margin-top-sm">发布招工</p>
				</div>
				<div class="card flex flex-direction justify-center align-center pointer" @click="golink('worker')">
					<img class="findjob" src="../../assets/img/findjob.png" >
					<p class="margin-top-sm">我要找活</p>
				</div>
				<div class="card flex flex-direction justify-center align-center pointer" @click="golink('skill')">
					<img class="training" src="../../assets/img/training.png" >
					<p class="margin-top-sm">技能培训</p>
				</div>
				<div class="card flex flex-direction justify-center align-center pointer" @click="golink('lease')">
					<img class="lease" src="../../assets/img/lease.png" >
					<p class="margin-top-sm">二手租赁</p>
				</div>
			</div>
			<div class="margin-top-sm">
				<div class="flex align-center justify-between margin-bottom-sm">
					<p class="title padding-left-sm">最新岗位</p>
					<div class="flex align-center">
						<p class="station text-sm margin-left-sm pointer" v-for="(item,index) in profession" :key="index" @click="schose(item)" :class="item.ischeck?'bg-theme text-white':''">{{item.short_name}}</p>
					</div>
				</div>
				<el-row :gutter="0" v-if="workList.length != 0">
					<el-col :span="8"  v-for="(item,index) in workList" :key="index"><StationList :data="item" :width="387" :height="168"></StationList></el-col>
				</el-row>
				<div class="text-center" v-else>
					<el-empty description="暂无数据"></el-empty>
				</div>
			</div>
			<div class="margin-top-sm">
				<div class="flex align-center justify-between margin-bottom-sm">
					<p class="title padding-left-sm">最新简历</p>
					<div class="flex align-center">
						<p class="station text-sm margin-left-sm pointer" @click="choseuser(1)" :class="resume == 1?'bg-theme text-white':''">班组长</p>
						<p class="station text-sm margin-left-sm pointer" @click="choseuser(3)" :class="resume == 3?'bg-theme text-white':''">突击队</p>
						<p class="station text-sm margin-left-sm pointer" @click="choseuser(2)" :class="resume == 2?'bg-theme text-white':''">施工队</p>
						<p class="station text-sm margin-left-sm pointer" @click="choseuser(0)" :class="resume == 0?'bg-theme text-white':''">个人简历</p>
					</div>
				</div>
				<el-row :gutter="0" v-if="userList.length != 0">
					<el-col :span="8"  v-for="(item,index) in userList" :key="index"><ResumeList :data="item" :width="387" :height="168"></ResumeList></el-col>
				</el-row>
				<div class="text-center" v-else>
					<el-empty description="暂无数据"></el-empty>
				</div>
			</div>
			<!-- <div class="look-more">查看更多</div> -->
		</div>
		<right type="1"></right>
		
		<div class="tan flex flex-direction align-end pointer" v-if="istan"  @click="golink('center','integral')">
			<img class="close pointer" @click="istan = false" src="https://manage.ciiply.com/web/static/home/tab-close.png" mode="">
			<img class="song" src="https://manage.ciiply.com/web/static/home/song.png" mode="">
		</div>
		<router-view />
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	import Top from '@/components/public/top.vue';
	import StationList from '@/components/list/station-list.vue';
	import ResumeList from '@/components/list/resume-list.vue';
	import Right from '@/components/public/right.vue';
	export default {
		components: {
			Top,
			StationList,
			ResumeList,
			Right
		},
		name: '',
		data() {
			return {
				station:0,//岗位
				resume:0,//简历
				workList:[],//招聘岗位列表
				userList:[],//招工人列表
				profession:[],//获取首页用工分类
				banner:[],//轮播
				istan:true,
				workCategroyId:0
			}
		},
		computed: {
			city(){
				return this.$store.getters.city;
			}
		},
		created() {
			Bus.$emit('chosename','home')
			
			this.getworkCategroy()
			this.getWorkList()
			this.getUserList()
			this.getopbanner()
			Bus.$on('chagecity',()=>{
				this.getworkCategroy()
				this.getopbanner()
				this.getWorkList()
				this.getUserList()
			})
			
		},
		beforeDestroy() {
			Bus.$off('chagecity')
		},
		methods: {
			/**
			 * 获取首页用工分类
			 * */
			getopbanner(){
				this.ajax('get', '/api/pc/Ad/getList', {}, res => {
					console.log('getopbanner',res);
					this.banner= res.data
				})
			},
			//轮播点击
			gobanlink(item){
				if(item.link){
					window.location.href = item.link
				}
			},
			/**
			 * 跳转页面
			 * name   string   页面路由
			 * type   string   页面传参判断个人中心显示组件
			 * */
			golink(name,type){
				if(name == 'center'&&!localStorage.getItem('user_token')){
					return Bus.$emit("showlogon")
				}
				let query = {}
				if(type){
					query.type = type
				}
				this.$router.push({
					name:name,
					query
				})
			},
			/**
			 * 选择找工人类型
			 * index  string  0:个人,1:班组,2:施工队,3:突击队
			 * */
			choseuser(index){
				this.resume = index
				this.getUserList()
			},
			/**
			 * 选择岗位类型
			 * */
			schose(item){
				this.workCategroyId = item.id
				this.profession.map(ele=>{
					ele.ischeck = false
					if(ele.id == item.id){
						item.ischeck = true
					}
				})
				// this.resume = index
				this.getWorkList()
			},
			/**
			 * 获取首页用工分类
			 * */
			getworkCategroy(){
				this.ajax('get', '/api/pc/workCategroy/hotJob', {}, res => {
					console.log('getworkCategroy',res);
					let arr = {
						id:0,
						short_name:'全部岗位',
						ischeck:true
					}
					res.data.map(item=>{
						item.ischeck = false
					})
					res.data.unshift(arr)
					this.profession= res.data
				})
			},
			/**
			 * 获取招聘岗位
			 * */
			getWorkList(){
				this.ajax('get', '/api/pc/work/getWorkList', {
					area:this.city,
					page:1,
					workCategroyId:this.workCategroyId == 0?'':this.workCategroyId
				}, res => {
					if(res.status == 200){
						this.workList = res.data.data
					}
				})
			},
			/**
			 * 获取招工人列表
			 * */
			getUserList(){
				this.ajax('get', '/api/pc/userInfo/getList', {
					area:this.city,
					stat:6,
					type:this.resume,
					page:1
				}, res => {
					if(res.status == 200){
						console.log('getUserList',res);
						this.userList = res.data.data
					}
				})
			},
		}
	}
</script>

<style scoped lang="less">
	.cont{
		width: 1210px;
		margin: 0 auto;
		.card{
			width: 278px;
			height: 191px;
			background: #FFFFFF;
			border-radius: 8px;
			.release{
				width:71px;
				height:71px;
			}
			.findjob{
				width:66px;
				height:70px;
			}
			.training{
				width:70px;
				height:70px;
			}
			.lease{
				width:70px;
				height:71px;
			}
		}
		.card:hover{
			box-shadow: 0px 5px 29px 2px rgba(123,172,241,0.3000);
			border-bottom: 8px solid #09827B;
		}
		.title{
			position: relative;
			font-size: 28px;
			&:before{
				position: absolute;
				left: 0;
				top: 50%;
				transform: translateY(-50%);
				width: 6px;
				height: 26px;
				background: #09827B;
				content: '';
				
			}
		}
		.station{
			width: 96px;
			height: 35px;
			line-height: 35px;
			background: #FFFFFF;
			border-radius: 18px;
		}
		.look-more{
			width: 227px;
			height: 42px;
			line-height: 42px;
			background: #FFFFFF;
			box-shadow: 0px 5px 19px 1px rgba(245,244,244,0.2000);
			border-radius: 8px;
			color: #1A8A84;
			margin: 45px auto 90px;
		}
	}
	.tan{
		position: fixed;
		bottom: 100px;
		right: 16px;
	}
</style>



// WEBPACK FOOTER //
// src/view/tab/home.vue